/**
 * Announces updated collection/search results to screen readers when Boost applies filters
 * (aria-live status region; does not move focus).
 */
(function () {
  var LIVE_ID = 'boost-pfs-filter-results-status';
  /** Skip first API response (initial collection/search render). */
  var skipInitialCalls = 1;
  var callCount = 0;

  function ensureLiveRegion() {
    var el = document.getElementById(LIVE_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = LIVE_ID;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-atomic', 'true');
      el.className = 'visually-hidden';
      document.body.appendChild(el);
    }
    return el;
  }

  function replaceCountPlaceholder(template, count) {
    if (!template || typeof template !== 'string') return null;
    return template
      .replace(/\{\{\s*count\s*\}\}/g, String(count))
      .replace(/\{\{count\}\}/g, String(count));
  }

  function buildMessage(result) {
    var total = null;
    if (result && typeof result === 'object') {
      if (typeof result.total_product === 'number') total = result.total_product;
      else if (result.data && typeof result.data.total_product === 'number') {
        total = result.data.total_product;
      }
    }
    if (total === null) {
      var t = document.querySelector('.boost-pfs-filter-total-product');
      if (t && t.textContent) {
        var m = t.textContent.match(/\d+/);
        if (m) total = parseInt(m[0], 10);
      }
    }

    var labelOne =
      typeof boostPFSConfig !== 'undefined' &&
      boostPFSConfig.label &&
      boostPFSConfig.label.items_with_count_one;
    var labelOther =
      typeof boostPFSConfig !== 'undefined' &&
      boostPFSConfig.label &&
      boostPFSConfig.label.items_with_count_other;

    if (total === 1 && labelOne) {
      var s = replaceCountPlaceholder(labelOne, 1);
      if (s) return 'Results updated. ' + s;
    }
    if (total !== null && typeof total === 'number' && labelOther) {
      var s2 = replaceCountPlaceholder(labelOther, total);
      if (s2) return 'Results updated. ' + s2;
    }
    if (total !== null) {
      return 'Results updated. ' + total + ' products.';
    }
    return 'Results updated.';
  }

  function announce(message) {
    var el = ensureLiveRegion();
    el.textContent = '';
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        el.textContent = message;
      });
    });
  }

  function wrapAfterCall() {
    if (typeof FilterApi === 'undefined' || typeof FilterApi.afterCall !== 'function') {
      return false;
    }
    if (FilterApi.afterCall._mgFilterStatusWrapped) return true;

    var previous = FilterApi.afterCall;
    FilterApi.afterCall = function (result, eventType, eventInfo) {
      previous.apply(this, arguments);
      callCount++;
      if (callCount <= skipInitialCalls) return;
      announce(buildMessage(result));
    };
    FilterApi.afterCall._mgFilterStatusWrapped = true;
    return true;
  }

  function tryWrap() {
    if (wrapAfterCall()) return;
    var attempts = 0;
    var id = window.setInterval(function () {
      attempts++;
      if (wrapAfterCall() || attempts > 60) window.clearInterval(id);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryWrap);
  } else {
    tryWrap();
  }

  window.MG_BOOST_PFS_FILTER_STATUS_A11Y = { refresh: tryWrap };
})();
